import { action, configure, decorate, observable } from 'mobx';
import { convertArrayToObject } from './utils';

configure({ enforceActions: 'always' });

class ProviderStore {
  constructor() {
    this.initialize();
  }

  setProperty = (key, value) => {
    this[key] = value;
  };

  initialize = () => {
    this.setProperty('providerSettings', []);
    this.setProperty('providerEvents', []);
    this.setProperty('language', 'en-us');
  };

  setProviderSettings = (data) => {
    const obj = convertArrayToObject(data, 'providerSetting');
    this.setProperty('providerSettings', obj);
    this.setProperty('providerSettings', {
      ...obj,
      ApiLogLevel: 'errors', // "verbose", "errors", null
      LogLevel: 'verbose', // "verbose", "errors", null
      deleteLogOnNextUnit: false, // generally use to evaluate event timelines
      showLogOnSuccess: true, // allow for viewing log when we have a successful connection
      skipPingsOnSuccess: true, // enable when we don't want to see all the ping/pongs
      loggedSuccessfulConnection: false, // write to log when we successfully connect
      showLogViewer: false, // whether to show the logs on screen
      logViewerFullscreen: false, // whether to show the logs in fullscreen mode
    });
    // console.log('providerSettings', this.providerSettings);
  };

  getProviderSettingByKey = (key) => this.providerSettings[key];

  getProviderEventsByType = (type) =>
    this.providerEvents.filter((item) => item.eventTypeId === type);
}

decorate(ProviderStore, {
  getProviderEventsByType: action,
  getProviderSettingByKey: action,
  initialize: action,
  language: observable,
  providerEvents: observable,
  providerSettings: observable,
  setProperty: action,
  setProviderSettings: action,
});

export default ProviderStore;
